import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import {Patient} from '../../models/patient';
import {DatePipe, formatDate} from '@angular/common';
import {
    CustomValidatorsModule,
    errorMessages,
    OapErrorMessages,
    OapStandarErrorStateMatcher,
    regExps
} from '../../modules/custom-validators/custom-validators.module';
import {TypeDocument} from '../../models/typeDocument';
import {DialogData} from '../../upload/dialog/dialog.component';
import {MessageService} from '../../services/message.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../services/authentication.service';
import {AlertService} from '../../services/alert.service';
import {DateAdapter} from '@angular/material/core';
import {PatientService} from '../../services/patient.service';
import {LoaderService} from '../../services/loader.service';
import {TypeDocumentService} from '../../services/type-document.service';
import {DisclaimerService} from '../../services/disclaimer.service';
import {TrackingService} from '../../services/tracking.service';
import {StorageService} from '../../services/storage.service';
import {CompteService} from '../../services/compte.service';
import {first, tap} from 'rxjs/operators';
import {DialogDataImpl} from '../../models/dialogDataImpl';
import {Moment} from 'moment';
import {environment} from '../../../environments/environment';
import {AppConfigService} from '../../services/app-config.service';
import {RECAPTCHA_URL} from '../../directives/recaptcha.directive';
import {JJMMYYYY_FORMAT_PROVIDER} from '../../helpers/jjmmyyy-format.helper';
import {CurrentPatientService} from '../../services/current-patient.service';

@Component({
  selector: 'oap-associated-profiles',
  templateUrl: './associated-profiles.component.html',
  styleUrls: ['./associated-profiles.component.scss'],
    providers: [{
        provide: RECAPTCHA_URL,
        useValue: 'http://localhost:3000/validate_captcha'
    }, ...JJMMYYYY_FORMAT_PROVIDER
    ]
})
export class AssociatedProfilesComponent implements OnInit, OnDestroy {
    @ViewChild('fileDocAutre')
    editMyInfoForm: FormGroup;
    editSocialSecurityForm: FormGroup;
    editMutuelleForm: FormGroup;
    ordoForm: FormGroup;
    createProfileForm: FormGroup;
    submitMyInfoLoading = false;
    submitSSLoading = false;
    submitMutuelleLoading = false;
    submitNewProfileLoading = false;
    submittedMyInfo = false;
    submittedSS = false;
    submittedMutuelle = false;
    patientId: number;
    firstPatientId: number;
    parentPatient = null;
    medecinKey: number;
    adresseKey: number;
    patientModel: Observable<Patient>;
    parentPatientModel: Observable<Patient>;
    readOnlyPhysicianName = false;
    minDate = new Date(1900, 0, 1);
    maxDate: Date = new Date(formatDate(Date.now(), 'MM/dd/yyyy', 'en'));

    matcher = new OapStandarErrorStateMatcher();
    errors = errorMessages;
    validation_messages = OapErrorMessages;

    maxDocs: Set<{ typeDocumentKey: string, maxDoc: number }> = new Set();

    typesDocuments: TypeDocument[];

    docAssuranceMaladie: DialogData;
    showHelpAttAsm = false;
    docMutuelle: DialogData;
    showHelpAttMut = false;
    docAutre: DialogData;
    identifiantSAP: string;
    showHelpAttOrdo = false;

    isParent: boolean;
    mobileParent: string;
    phoneParent: string;
    mailParent: string;

    siteKey: string;

    public mask = [/[1-4,7-8]/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /[0-9A-B]/, ' ',
        /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/];
    public maskTel = [/\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/];

    public subscription;

    public infoIsShowed = false;
    public infoSecuShowed = false;

    public currentPatient = null;
    public currentCompte = null;
    public noMutuelleChecked = false;
    public associatedProfiles = null;
    public currentPatientSelected = false;
    public showModalCreate = false;
    public createPatientSubmitted = false;
    constructor(private messageService: MessageService,
                private formBuilder: FormBuilder,
                private route: ActivatedRoute,
                private router: Router,
                private authenticationService: AuthenticationService,
                private alertService: AlertService,
                private adapter: DateAdapter<any>,
                private patientService: PatientService,
                private loaderService: LoaderService,
                private typeDocumentService: TypeDocumentService,
                private disclaimer: DisclaimerService,
                private tracking: TrackingService,
                private storageService: StorageService,
                private compteService: CompteService,
                private _appConfig: AppConfigService,
                private currentPatientService: CurrentPatientService) {
        this.mobileParent = '';
        this.phoneParent = '';
        this.mailParent = '';
    }

    ngOnInit() {
        this.loaderService.showLoader();
        this.alertService.clear();
        this.messageService.sendMessage('page-associated-profiles');
        this.siteKey = this._appConfig.config.reCaptchaSiteKey;

        if (!environment.production && !environment.preprod) {
            this.siteKey = '6Levgq8UAAAAACarJKYgQEbcMphFaXlbUlThZkmS';
        }
        this.adapter.setLocale('fr');
        this.firstPatientId = parseInt(JSON.parse(localStorage.getItem('firstPatientId')));
        this.patientService.getPatient(this.firstPatientId).subscribe((mainPatient) => {
            this.parentPatient = mainPatient;
            const patientIdSelected = this.route.snapshot.paramMap.get('id');
            if (patientIdSelected !== undefined && patientIdSelected !== null) {
                this.currentPatientSelected = true;
                this.infoPatient(parseInt(patientIdSelected));
            } else {
                this.getAssociatedProfiles();
            }
        });
        this.subscription = this.storageService.watchStorage().subscribe(() => {
            this.infoPatient();
        });
        this.tracking.DataLayer('/app/associated-profiles', 'Rubrique', 'Mon profil', '');
    }

    ngOnDestroy() {
        if (this.subscription !== undefined) {
            this.subscription.unsubscribe();
        }
    }

    public openExternal(url: string) {
        this.disclaimer.openPopinExternal(url);
    }

    private loadDocument(patientKey: number) {
        this.typeDocumentService.getAll().pipe(first()).subscribe(tdo => {
            if (tdo) {
                const t = tdo.find(a => a.typeDocumentKey === 'ATT_ASS_MA');
                this.docAssuranceMaladie = new DialogDataImpl(patientKey, t);
                this.docMutuelle = new DialogDataImpl(patientKey, tdo.find(a => a.typeDocumentKey === 'ATT_MUT'));
                this.docAutre = new DialogDataImpl(patientKey, tdo.find(a => a.typeDocumentKey === 'ORD'));

                tdo.forEach(f => {
                    this.maxDocs.add({typeDocumentKey: f.typeDocumentKey, maxDoc: f.nbDocumentMax});
                });
            }
        });
    }

    public onMyInfoFormSubmit(form) {
        this.submitMyInfoLoading = true;
        this.submittedMyInfo = true;

        // stop here if form is invalid
        if (this.editMyInfoForm.invalid) {
            return;
        }

        const dateNaiss: Moment = form.controls.dateNaissance.value;
        const datePipe = new DatePipe('en');

        const patientUpdate = {
            nom: form.controls.lastName.value,
            prenom: form.controls.firstName.value,
            dateNaissance: datePipe.transform(dateNaiss, 'yyyy-MM-dd'),
        };

        this.patientService.updateAffiliatedPatientIdentity(patientUpdate, this.patientId)
            .pipe(first())
            .subscribe(
                obsData => {
                    this.alertService.success('Modifications enregistrées', true);
                    this.submitMyInfoLoading = false;
                },
                error => {
                    this.alertService.error(error);
                    this.submitMyInfoLoading = false;
                });
    }

    public onSocialSecurityFormSubmit(form) {
        this.submitSSLoading = true;
        this.submittedSS = true;

        // stop here if form is invalid
        if (this.editSocialSecurityForm.invalid) {
            return;
        }
        let numSS: string = form.controls.numeroSecuriteSociale.value;
        // permet de supprimer les espaces contenu dans le mask mask
        // a voir pour les validator si on peut les conserver
        // TODO ajout un validator pour vérifier la clé fourni
        numSS = numSS ? numSS.replace(/\s/g, '') : null;
        let nomCPAM = form.controls.nomCPAM.value;
        let attachedToSS = false;
        if (form.controls.parentSecuritySocial.value === '1') {
            numSS = this.parentPatient.numeroSecuriteSociale;
            nomCPAM = this.parentPatient.nomCPAM;
            attachedToSS = true;
        }
        const patientUpdate = {
            numeroSecuriteSociale: numSS,
            nomCPAM: nomCPAM,
            attachedToSocialSecurity: attachedToSS
        };
        this.patientService.updateAffiliatedPatientSS(patientUpdate, this.patientId)
            .pipe(first())
            .subscribe(
                obsData => {
                    this.alertService.success('Modifications enregistrées', true);
                    this.submitSSLoading = false;
                },
                error => {
                    this.alertService.error(error);
                    this.submitSSLoading = false;
                });
    }

    public onMutuelleFormSubmit(form) {
        this.submitMutuelleLoading = true;
        this.submittedMutuelle = true;
        let mutuelleCodePrefectoral = form.controls.mutuelleCodePrefectoral.value;
        let mutuelleNumeroAdherent = form.controls.mutuelleNumeroAdherent.value;
        let nomMutuelle = form.controls.nomMutuelle.value;
        let mutuelleDateFinDroit: Moment = form.controls.mutuelleDateFinDroit.value;
        let attachedToMutual = false;
        if (form.controls.parentMutuelle.value === '1') {
            mutuelleCodePrefectoral = this.parentPatient.mutuelleCodePrefectoral;
            mutuelleNumeroAdherent = this.parentPatient.mutuelleNumeroAdherent;
            nomMutuelle = this.parentPatient.nomMutuelle;
            mutuelleDateFinDroit = this.parentPatient.mutuelleDateFinDroit;
            attachedToMutual = true;
        } else if (form.controls.sansMutuelle.value) {
            mutuelleCodePrefectoral = null;
            mutuelleNumeroAdherent = null;
            nomMutuelle = null;
            mutuelleDateFinDroit = null;
        }

        // stop here if form is invalid
        if (this.editMutuelleForm.invalid) {
            return;
        }
        const datePipe = new DatePipe('en');
        const patientUpdate = {
            mutuelleCodePrefectoral: mutuelleCodePrefectoral,
            mutuelleNumeroAdherent: mutuelleNumeroAdherent,
            nomMutuelle: nomMutuelle,
            mutuelleDateFinDroit: datePipe.transform(mutuelleDateFinDroit, 'yyyy-MM-dd'),
            patientSansMutuelle: form.controls.sansMutuelle.value,
            attachedToMutual: attachedToMutual
        };
        this.patientService.updateAffiliatedPatientMutual(patientUpdate, this.patientId)
            .pipe(first())
            .subscribe(
                obsData => {
                    this.alertService.success('Modifications enregistrées', true);
                    this.submitMutuelleLoading = false;
                },
                error => {
                    this.alertService.error(error);
                    this.submitMutuelleLoading = false;
                });
    }

    public clickMutuelle(event) {
        this.noMutuelleChecked = !this.noMutuelleChecked;
        if ( event.checked ) {
            this.editMutuelleForm.get('nomMutuelle').setValidators([]);
            this.editMutuelleForm.get('nomMutuelle').updateValueAndValidity();
            this.tracking.pushDataLayer('Gestion profil', 'Click', 'Pas de mutuelle');
        } else {
            this.editMutuelleForm.get('nomMutuelle').setValidators([Validators.required]);
            this.editMutuelleForm.get('nomMutuelle').updateValueAndValidity();
        }
    }

    public help(id) {
        if (id === 'ATT_ASM') {
            this.showHelpAttAsm = !this.showHelpAttAsm;
        } else {
            this.showHelpAttAsm = false;
        }

        if (id === 'ATT_MUT') {
            this.showHelpAttMut = !this.showHelpAttMut;
        } else {
            this.showHelpAttMut = false;
        }

        if (id === 'ATT_ORDO') {
            this.showHelpAttOrdo = !this.showHelpAttOrdo;
        } else {
            this.showHelpAttOrdo = false;
        }

        if (!id) {
            this.showHelpAttMut = false;
            this.showHelpAttAsm = false;
        }
    }

    public onClick(e) {
        this.showHelpAttAsm = false;
        this.showHelpAttMut = false;
    }

    private infoPatient(patientId = null) {
        if (patientId === null) {
            this.patientId = parseInt(JSON.parse(localStorage.getItem('patientId')));
        } else {
            this.patientId = patientId;
        }
        this.isParent = (this.patientId === this.firstPatientId);

        this.loadDocument(this.patientId);
        this.editMyInfoForm = this.formBuilder.group({
            lastName: ['', [Validators.required,
                Validators.maxLength(40),
                Validators.pattern(regExps.onlyLetters)]],
            firstName: ['', [Validators.required,
                Validators.maxLength(40),
                Validators.pattern(regExps.onlyLettersAccent)]],
            dateNaissance: [''],
        });
        this.editSocialSecurityForm = this.formBuilder.group({
            parentSecuritySocial: [''],
            numeroSecuriteSociale: ['', [Validators.required, CustomValidatorsModule.maskMinValidator(15),
                CustomValidatorsModule.checkNirKeyValidator()]],
            nomCPAM: ['', Validators.maxLength(100)],
        });
        this.editMutuelleForm = this.formBuilder.group({
            parentMutuelle: [''],
            nomMutuelle: ['', [Validators.required, Validators.maxLength(100)]],
            mutuelleCodePrefectoral: ['', Validators.maxLength(20)],
            mutuelleNumeroAdherent: ['', Validators.maxLength(20)],
            mutuelleDateFinDroit: [''],
            sansMutuelle: [''],
        });

        this.ordoForm = this.formBuilder.group({
            ordoMedecin: ['']
        });

        if (!this.isParent) {
            this.patientService.getPatient(this.firstPatientId).subscribe(
                data => {
                    this.mobileParent = data.mobile;
                    this.phoneParent = data.telephoneFixe;
                    this.mailParent = data.email;
                }
            );
        }

        this.patientModel = this.patientService.getPatient(this.patientId).pipe(
            tap(patient => {
                    this.patchValuesInForm(patient);
                    this.readOnlyPhysicianName = patient.medecinKey ? true : false;
                    this.medecinKey = patient.medecinKey;
                    this.adresseKey = patient.adresse ? patient.adresse.adresseKey : null;
                    this.identifiantSAP = patient.identifiantSAP;
                    this.loaderService.hideLoader();
                    this.currentPatient = patient;
                    this.currentPatient.patientSansMutuelle ? this.noMutuelleChecked = true : this.noMutuelleChecked = false;
                    if (this.currentCompte === null) {
                        this.compteService.getById(this.parentPatient.compteKey).subscribe((compte) => {
                            this.currentCompte = compte;
                        });
                    }
                    if (this.associatedProfiles === null) {
                        this.compteService.getPatientsAffiliated(this.parentPatient.compteKey).pipe(first()).subscribe(pat => {
                            if (pat) {
                                this.associatedProfiles = pat;
                            }
                        });
                    }
                }
            )
        );
    }

    private patchValuesInForm(patient) {
        const numSS = this.parentPatient.numeroSecuriteSociale;
        const nomCPAM = this.parentPatient.nomCPAM;
        const mutuelleCodePrefectoral = this.parentPatient.mutuelleCodePrefectoral;
        const mutuelleNumeroAdherent = this.parentPatient.mutuelleNumeroAdherent;
        const nomMutuelle = this.parentPatient.nomMutuelle;
        const mutuelleDateFinDroit = this.parentPatient.mutuelleDateFinDroit;
        this.editMyInfoForm.patchValue(
            {
                lastName: patient.nom,
                firstName: patient.prenom,
                dateNaissance: patient.dateNaissance,
            });
        this.editSocialSecurityForm.patchValue(
            {
                parentSecuritySocial: ((numSS === patient.numeroSecuriteSociale) && (nomCPAM === patient.nomCPAM)) ? '1' : '2',
                numeroSecuriteSociale: patient.numeroSecuriteSociale,
                nomCPAM: patient.nomCPAM,
            });
        this.editMutuelleForm.patchValue(
            {
                parentMutuelle: ((mutuelleCodePrefectoral === patient.mutuelleCodePrefectoral) && (mutuelleNumeroAdherent === patient.mutuelleNumeroAdherent) && (nomMutuelle === patient.nomMutuelle) && (mutuelleDateFinDroit === patient.mutuelleDateFinDroit)) ? '1' : '2',
                nomMutuelle: patient.nomMutuelle,
                mutuelleNumeroAdherent: patient.mutuelleNumeroAdherent,
                mutuelleCodePrefectoral: patient.mutuelleCodePrefectoral,
                mutuelleDateFinDroit: patient.mutuelleDateFinDroit,
                sansMutuelle: patient.patientSansMutuelle,
            });
    }

    public getAssociatedProfiles() {
        this.patientId = parseInt(JSON.parse(localStorage.getItem('patientId')));
        this.patientService.getPatient(this.patientId).subscribe(
            (patient) => {
                this.currentPatient = patient;
                if (this.currentCompte === null) {
                    this.compteService.getById(this.parentPatient.compteKey).subscribe((compte) => {
                        this.currentCompte = compte;
                    });
                }
                if (this.associatedProfiles === null) {
                    this.compteService.getPatientsAffiliated(this.parentPatient.compteKey).pipe(first()).subscribe(pat => {
                        if (pat) {
                            this.associatedProfiles = pat;
                        }
                    });
                }
                this.loaderService.hideLoader();
            });
    }

    public showInfo() {
        this.infoIsShowed = !this.infoIsShowed;
    }

    public showInfoSecu() {
        this.infoSecuShowed = !this.infoSecuShowed;
    }

    public switchPatient(patientId: number) {
        if (patientId === parseInt(JSON.parse(localStorage.getItem('firstPatientId')))) {
            this.router.navigate(['/my-profil']);
        } else {
            this.currentPatientSelected = true;
            this.currentPatientService.updateCurrentPatient(patientId);
        }
    }

    public openModalCreate() {
        this.showModalCreate = true;
        this.createPatientSubmitted = false;
        this.createProfileForm = this.formBuilder.group({
            lastNameCreate: ['', [Validators.required,
                Validators.maxLength(40),
                Validators.pattern(regExps.onlyLetters)]],
            firstNameCreate: ['', [Validators.required,
                Validators.maxLength(40),
                Validators.pattern(regExps.onlyLettersAccent)]],
            dateNaissanceCreate: ['']
        });
    }

    public closeModalCreate() {
        this.showModalCreate = false;
    }

    public onCreateProfileFormSubmit(form) {
        if (!this.createPatientSubmitted) {
            const dateNaiss: Moment = form.controls.dateNaissanceCreate.value;
            const datePipe = new DatePipe('en');
            const data = {
                'dateNaissance': datePipe.transform(dateNaiss, 'yyyy-MM-dd'),
                'nom': form.controls.lastNameCreate.value,
                'prenom': form.controls.firstNameCreate.value
            };
            this.patientService.createAssociatedPatient(data).subscribe((res) => {
                if (res) {
                    this.createPatientSubmitted = true;
                    this.alertService.success('Le nouveau patient a bien été ajouté', true);
                    this.closeModalCreate();
                    this.associatedProfiles.push(res);
                    this.compteService.getPatientsAffiliated(this.parentPatient.compteKey).pipe(first()).subscribe(pat => {
                        this.storageService.setItem('patients', JSON.stringify(pat));
                    });
                }
            });
        }
    }

    public updateValidatorSocialSecurity(event: any) {
        if (event.value === '1') {
            this.editSocialSecurityForm.get('numeroSecuriteSociale').setValidators([]);
            this.editSocialSecurityForm.get('numeroSecuriteSociale').updateValueAndValidity();
        } else if (event.value === '2') {
            this.editSocialSecurityForm.get('numeroSecuriteSociale').setValidators([Validators.required]);
            this.editSocialSecurityForm.get('numeroSecuriteSociale').updateValueAndValidity();
        }
    }

    public updateValidatorMutuelle(event: any) {
        if (event.value === '1') {
            this.editMutuelleForm.get('nomMutuelle').setValidators([]);
            this.editMutuelleForm.get('nomMutuelle').updateValueAndValidity();
        } else if (event.value === '2') {
            this.editMutuelleForm.get('nomMutuelle').setValidators([Validators.required]);
            this.editMutuelleForm.get('nomMutuelle').updateValueAndValidity();
        }
    }
}
